export const NO_INTERCHANGES_AVAILABLE = "NO_INTERCHANGES_AVAILABLE";
export const GETTING_DATA_FROM_PLATFORM = "GETTING_DATA_FROM_PLATFORM";
export const NO_VALID_STOPS_FOR_INTERCHANGE = "NO_VALID_STOPS_FOR_INTERCHANGE";
export const STORING_DATA_IN_CACHE = "STORING_DATA_IN_CACHE";
export const NO_ROLE_RIGHT = "NO_ROLE_RIGHT";
